import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface RecordDetailField {
    label: string;
    value: string | number | null | undefined;
    mono?: boolean;
}

export interface RecordDetailSection {
    title: string;
    fields: RecordDetailField[];
}

export interface RecordDetailAction {
    label: string;
    action: string;
    danger?: boolean;
}

/** The body of a detail drawer that is a plain set of labelled sections, plus the actions the row offers. */
@Component({
    selector: 'app-record-detail',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './record-detail.component.html',
    styleUrls: ['./record-detail.component.scss'],
})
export class RecordDetailComponent {
    @Input() sections: RecordDetailSection[] = [];
    @Input() actions: RecordDetailAction[] = [];

    /** The `action` of the button pressed. The page decides what it does. */
    @Output() action = new EventEmitter<string>();
}
